import styled from "styled-components";

type ContainerType = {
    background: string;
};

export const Container = styled.div<ContainerType>`
  display: flex;
  width: 500px;
  overflow: auto;
  flex-direction: column;
  border-radius: 7px;
  background: ${(props) => props.background};
`;

export const ContainerForm = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
`;